'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Fragment, useState } from 'react';
import { Link } from '../../../../actions/Link';
import { AlgoAcademyHorizontalLogo } from '../../../logos/AlgoAcademyHorizontalLogo';
import { MobileMenuDisclosure } from '../_components/MobileMenuDisclosure';
import { MobileMenuLink } from '../_components/MobileMenuLink';
import { aboutLinks, manageSiteLinks, mentoringPodstawowyGoals, mentoringProjektowyGoals, mentoringSpersonalizowanyGoals } from '../_components/NavigationItems';
export function NavbarMobile(t0) {
  const $ = _c(27);
  const {
    canManageSite
  } = t0;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setMobileMenuOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Bars3Icon className="h-6 w-6" aria-hidden="true" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mobileMenuOpen) {
    t3 = <div className="flex lg:hidden"><Button type="button" className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-slate-700" onClick={t1} aria-label={"Otw\xF3rz menu"} aria-expanded={mobileMenuOpen} aria-controls="mobile-navigation">{t2}</Button></div>;
    $[2] = mobileMenuOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setMobileMenuOpen(false);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/25" aria-hidden="true" /></TransitionChild>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DialogTitle className="sr-only">Menu główne</DialogTitle>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex lg:flex-1"><Link href="/" className="-m-1.5 p-1.5"><span className="sr-only">AlgoAcademy</span><AlgoAcademyHorizontalLogo className="h-8 w-auto" /></Link></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setMobileMenuOpen(false);
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-center justify-between">{t7}<Button type="button" className="-m-2.5 rounded-md p-2.5 text-slate-700" onClick={t8} aria-label="Zamknij menu"><XMarkIcon className="h-6 w-6" aria-hidden="true" /></Button></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MobileMenuDisclosure title="O nas" items={aboutLinks} />;
    t11 = <MobileMenuDisclosure title="Oferta: Mentoring podstawowy" items={mentoringPodstawowyGoals} />;
    t12 = <MobileMenuDisclosure title="Oferta: Mentoring rozszerzony" items={mentoringSpersonalizowanyGoals} />;
    t13 = <MobileMenuDisclosure title="Oferta: Mentoring projektowy" items={mentoringProjektowyGoals} />;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  let t15;
  let t16;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <MobileMenuLink href="/kontakt" title="Kontakt" onClick={() => setMobileMenuOpen(false)} />;
    t15 = <MobileMenuLink href="/baza" title={"Baza wiedzy \u2192"} isHighlighted={true} />;
    t16 = <MobileMenuLink href="/app" title={"Aplikacja \u2192"} isHighlighted={true} />;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
  } else {
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] !== canManageSite) {
    t17 = canManageSite && <MobileMenuDisclosure title={"Zarz\u0105dzaj stron\u0105"} items={manageSiteLinks} />;
    $[17] = canManageSite;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t17) {
    t18 = <Dialog as="div" className="lg:hidden" onClose={t4}>{t5}<TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"><DialogPanel id="mobile-navigation" className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 pt-6 pb-[calc(1.5rem+env(safe-area-inset-bottom))] sm:max-w-sm sm:ring-1 sm:ring-slate-900/10">{t6}{t9}<nav className="mt-6 flow-root" aria-label="Menu mobilne"><div className="-my-6 divide-y divide-slate-500/10"><div className="space-y-2 py-6">{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</div></div></nav></DialogPanel></TransitionChild></Dialog>;
    $[19] = t17;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== mobileMenuOpen || $[22] !== t18) {
    t19 = <Transition show={mobileMenuOpen} as={Fragment}>{t18}</Transition>;
    $[21] = mobileMenuOpen;
    $[22] = t18;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t19 || $[25] !== t3) {
    t20 = <>{t3}{t19}</>;
    $[24] = t19;
    $[25] = t3;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  return t20;
}